<div class="padding-20 ui-g" *ngIf="show.form" id="customerTargetCouponForm">
  <div class="ui-g ui-g-6">
    <div class="selezionaListaBox ui-g ui-g-12">

      <div class="ui-g-12 labelTitle"
        [ngClass]="{'formHidden': formSchema.form.lista_distribuzione_emissione.visible == false }">
        {{formSchema.form.lista_distribuzione_emissione.label[language]}} <span
          *ngIf="listaDistribuzioneEmissione.required == true" class="asterix">*</span></div>
      <div class="ui-g-12 marginBreak"></div>
      <div class="ui-g-1">
        <div class="fa fa-search circleIcon" style="margin-top:10px" 
          [ngClass]="{'notPermitted': listaDistribuzioneEmissione.disabled == true || readOnly==true}"
          (click)="onClickSearchListaDistribuzione('E')"></div>
      </div>
      <div class="ui-g-11">
        <app-form-fields #listaDistribuzioneEmissione data-testid="listaDistribuzioneEmissione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.lista_distribuzione_emissione"
          (fieldModelChange)="onChangeListaDistribuzioneEmissione($event)" [showLabel]="false"
          [(fieldModel)]="fieldModel.listaDistribuzioneEmissione" [type]="'dropdown'"
          [options]="comboListaDistribuzioneEmissione" [filterable]="true" [optionLabel]="'distributionListName'"
          [placeholder]="'campaign.select_distribution_list' | translate"></app-form-fields>

      </div>
      <div class="ui-g-12">
        <br />
        <button pButton type="button" class="buttonActions buttonVisualizzaContenuto" icon="fa fa-eye" iconPos="left"
          label="{{'campaign.view_content_list' | translate}}"
          [ngClass]="{'notPermitted': !fieldModel.listaDistribuzioneEmissione }"
          (click)="onClickVisualizzaContenutoListaEmissione()"></button>
        <button pButton type="button" *ngIf="!readOnly" class="buttonActions buttonCreaNuova" icon="fa fa-plus"
          iconPos="left" label="{{'campaign.create_new_list' | translate}}"
          (click)="onClickCreaNuovaLista('E')"></button>
      </div>
    </div>
  </div>
  <div class="ui-g ui-g-6">


    <!--  <div class="selezionaListaBox ui-g ui-g-12">



        <app-form-fields #switchComeEmissione data-testid="switchComeEmissione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.switch_come_emissione" (fieldModelChange)="onChangeSwitchComeEmissione($event)"
          [(fieldModel)]="switch.comeEmissione"></app-form-fields>
        <br />
      </div>
      <br />
      <div class="ui-g-1">
        <div [ngClass]="{'notPermitted': listaDistribuzioneFruizione.disabled == true || readOnly==true}"
          class="fa fa-search circleIcon" (click)="onClickSearchListaDistribuzione('F')"></div>
      </div>
      <div class="ui-g-11">
        <app-form-fields #listaDistribuzioneFruizione data-testid="listaDistribuzioneFruizione" [filterable]="true" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.lista_distribuzione_fruizione"
          (fieldModelChange)="onChangeListaDistribuzioneFruizione($event)" [showLabel]="false"
          [(fieldModel)]="fieldModel.listaDistribuzioneFruizione" [type]="'dropdown'"
          [options]="comboListaDistribuzioneFruizione" [optionLabel]="'distributionListName'"
          [placeholder]="'Seleziona la lista di distribuzione'"></app-form-fields>
      </div>
      <div class="ui-g-12">
        <br />
        <button pButton type="button" class="buttonActions buttonVisualizzaContenuto" icon="fa fa-eye" iconPos="left"
          label="Visualizza contenuto lista" [ngClass]="{'notPermitted': !fieldModel.listaDistribuzioneFruizione }"
          (click)="onClickVisualizzaContenutoListaFruizione()"></button>
        <button *ngIf="!readOnly" pButton type="button" class="buttonActions buttonCreaNuova" icon="fa fa-plus"
          iconPos="left" label="Crea nuova lista" (click)="onClickCreaNuovaLista('F')"></button>
      </div>
    </div>
    <div class="ui-g-12 ui-g">
      <div class="ui-g-12 marginBreak"></div>

      <app-form-fields #switchCartaNecessaria data-testid="switchCartaNecessaria" [readOnly]="readOnly"
        [fieldSchema]="formSchema.form.switch_carta_necessaria" (fieldModelChange)="onChangeCartaNecessaria($event)"
        [(fieldModel)]="switch.cartaNecessaria"></app-form-fields>
      <div class="ui-g-12 marginBreak"></div>
      <div class="ui-g-12" *ngIf="switch.cartaNecessaria == true">
        <app-form-fields #tipoControllo data-testid="tipoControllo" [readOnly]="readOnly" [fieldSchema]="formSchema.form.tipo_controllo"
          (fieldModelChange)="onChangeTipoControllo($event)" [(fieldModel)]="fieldModel.tipoControllo"
          [placeholder]="'Seleziona il tipo di controllo'"></app-form-fields>
      </div>
      <br />
    </div>
 -->







  </div>
</div>




<p-dialog *ngIf="show.modalDistributionList && distributionList" [width]="1500" [height]="800"
  [(visible)]="show.modalDistributionList" [responsive]="true" [header]="'campaign.search_distribution_list' | translate"
  showEffect="fade" [modal]="true">


  <!-- Bottoni Annulla e Conferma -->
  <div class="ui-dialog-footer fixed-buttons buttonsContainer">
    <button pButton (click)="onClickAnnulla_ModalListDistribuzione()" type="button" class="k-generic-btn footer-btn"
      label="{{'common.cancel' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>

  <app-campaign-3-search-distribution-list #searchDistributionList
    (distributionListSelected)="onDistributionListSelected($event)"
    [distributionList]="distributionList"></app-campaign-3-search-distribution-list>


</p-dialog>




<p-dialog *ngIf="show.modalDistributionListDetails" [width]="1500" [height]="800"
  [(visible)]="show.modalDistributionListDetails" [responsive]="true" [header]="title.contenutoLista" showEffect="fade"
  [modal]="true">


  <!-- Bottoni Annulla e Conferma -->
  <div class="ui-dialog-footer buttonsContainer">
    <button pButton (click)="onClickAnnulla_ModalListDistribuzioneDetails()" type="button"
      class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>

  <app-campaign-3-view-distribution-list-details #searchDistributionListDetails
    [distributionListId]="currentDistributionListId"
    [distributionListDetails]="distributionListDetails"></app-campaign-3-view-distribution-list-details>

</p-dialog>


<!--
<p-dialog
*ngIf="show.modalDistributionListDetails"
[width]="1500"
[height]="800"
[(visible)]="show.modalDistributionListDetails"
[responsive]="true"
[header]="title.contenutoLista"
showEffect="fade"
[modal]="true"
>

<app-campaign-3-view-distribution-list-details #searchDistributionListDetails data-testid="searchDistributionListDetails" [distributionListDetails]="distributionListDetails"></app-campaign-3-view-distribution-list-details>


  <div class="ui-dialog-footer buttonsContainer">
    <button pButton (click)="onClickAnnulla_ModalListDistribuzioneDetails()" type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>

</p-dialog>
-->


<p-dialog *ngIf="show.modalClusterHeadNewList" [width]="1500" [height]="800" [(visible)]="show.modalClusterHeadNewList"
  [responsive]="true" [header]="title.creaNuovaLista" showEffect="fade" [modal]="true">

  <app-campaign-3-create-cluster-head-list #createClusterHeadList
    (clusterHeadListSelected)="onAggiungiClusterHead($event)" (clusterHeadListCancel)="onAnnullaClusterHead($event)"
    [clusterHeadList]="clusterHeadNewList" [actionDateStart]="currentActionDateStart"
    [actionDateEnd]="currentActionDateEnd"></app-campaign-3-create-cluster-head-list>


</p-dialog>


// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-customer-target/message-3-customer-target.component.html